import { useMemo } from 'react';
import { EditableRule, MultiSelectType } from '../../../../model/EditableRule';

export const useGenericHandler = <T>(
    fullList: T[],
    selectedItems: string[],
    keyName: keyof T,
    propName: string,
    handleRuleChange: (ruleData: Partial<EditableRule>) => void
) => {
    const itemMap = useMemo(() => {
        return fullList.reduce((acc: Record<string, T>, item: T) => {
            const itemKey = item[keyName] as string;
            acc[itemKey] = item;
            return acc;
        }, {});
    }, [fullList, keyName]);

    const addItem = (itemKey: string) => {
        handleRuleChange({ [propName]: [...selectedItems, itemKey] });
    };

    const removeItem = (itemKey: string) => {
        handleRuleChange({ [propName]: selectedItems.filter((item) => item !== itemKey) });
    };

    const removeAllItems = () => {
        handleRuleChange({ [propName]: [] });
    };

    const handleItemChange = (itemKey: string, checked: boolean) => {
        if (checked) {
            if (!selectedItems.includes(itemKey)) {
                addItem(itemKey);
            }
        } else if (selectedItems.includes(itemKey)) {
                removeItem(itemKey);
        }
    };

    const handleAllItemsChange = (itemsKey: string[], checked: boolean) => {
        handleRuleChange({ [propName]: checked ? [...itemsKey] : [] });
    };

    const handleTypeChange = (multiselectType: MultiSelectType) => {
        const updatedData: Partial<EditableRule> = {};
        updatedData[`${propName}Type` as keyof EditableRule] =
            multiselectType as any;
        if (multiselectType === MultiSelectType.ANY) {
            updatedData[propName as keyof EditableRule] = [] as any;
        }
        handleRuleChange(updatedData);
    };

    return { itemMap, handleItemChange, removeItem, removeAllItems, handleTypeChange, handleAllItemsChange };
};